module.exports = __webpack_public_path__ + "static/media/dinesafe-app-user.990872ec.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/dinesafe-app-user.png
// module id = 114
// module chunks = 0